export default __webpack_public_path__ + "static/media/landing.810e8b1f.jpg";